import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TileStyler } from '@angular/material/grid-list/tile-styler';

@Component({
  selector: 'anterasoftware-kanban-confirmation-modal',
  templateUrl: './kanban-confirmation-modal.component.html',
  styleUrls: ['./kanban-confirmation-modal.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class KanbanConfirmationModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<KanbanConfirmationModalComponent>, @Inject(MAT_DIALOG_DATA) public data:any ) { }

  @Input() public title: string = 'Are you Sure?';
  @Input() public message: string = '';
  @Input() public submitBtn: string = 'Submit';
  @Input() public cancelBtn: string = 'Cancel';
  @Input() public titleCss: string = '';
  @Input() public messageCss: string = '';
  @Input() public submitBtnCss: string = '';
  @Input() public cancelBtnCss: string = '';

  public ngOnInit(): void {
    this.setPageValues();
  }

  /**
   * Sets the values of the page.
   *
   * @returns {void}
   */
  public setPageValues(){

    if(this.data){

      if(this.data?.title?.length > 0){
        this.title = this.data?.title;
      }

      if(this.data?.message?.length > 0){
        this.message = this.data?.message;
      }

      if(this.data?.submitBtn?.length > 0){
        this.submitBtn = this.data?.submitBtn;
      }

      if(this.data?.cancelBtn?.length > 0){
        this.cancelBtn = this.data.cancelBtn;
      }

      if(this.data?.titleCss?.length > 0){
        this.titleCss = this.data.titleCss;
      }

      if(this.data?.messageCss?.length > 0){
        this.messageCss = this.data.messageCss;
      }

      if(this.data?.submitBtnCss?.length > 0){
        this.submitBtnCss = this.data.submitBtnCss;
      }

      if(this.data?.cancelBtnCss?.length > 0){
        this.cancelBtnCss = this.data.cancelBtnCss;
      }
    }

  }

  /**
   * Closes the dialog.
   *
   * @returns {void}
   */
  public close(){
    this.dialogRef.close();
  }

  /**
   * Submit clicked.
   *
   * @returns {void}
   */
  public submitClicked(){
    this.dialogRef.close(true);
  }

}
